import { createReducer, on } from '@ngrx/store';
import { imageBlockActions } from '../actions/image-block.actions';
import { ImageBlock } from '../models';

export interface ImageBlockState {
    images: Record<string, { loaded: boolean; loading: boolean | null; image: ImageBlock | null }>;
}

export const initialState: ImageBlockState = {
    images: {},
};

export const imageBlockReducer = createReducer(
    initialState,
    on(imageBlockActions.getImage, (state, action): ImageBlockState => {
        if (state.images[action.id]) {
            return state;
        }

        return {
            ...state,
            images: {
                ...state.images,
                [action.id]: { loaded: false, loading: null, image: null },
            },
        };
    }),
    on(imageBlockActions.getImageSuccess, (state, { payload }): ImageBlockState => ({
        ...state,
        images: {
            ...state.images,
            [payload.id]: { loaded: true, loading: false, image: payload },
        },
    })),
    on(imageBlockActions.getImageError, (state, { id }): ImageBlockState => ({
        ...state,
        images: {
            ...state.images,
            [id]: { loaded: false, loading: false, image: null },
        },
    })),
    on(imageBlockActions.setLoading, (state, payload): ImageBlockState => ({
        ...state,
        images: {
            ...state.images,
            [payload.id]: { loaded: false, loading: true, image: null },
        },
    })),
    on(imageBlockActions.clear, (): ImageBlockState => ({
        ...initialState,
    })),
);
